import Vue from 'vue'
import Vuex from 'vuex'
import vuexI18n from 'vuex-i18n'
import translationsCh from '../i18n/ch.json'
import translationsEn from '../i18n/en.json'
Vue.use(Vuex)

let store = new Vuex.Store({
	modules: {
		i18n: vuexI18n.store,
	}
})

Vue.use(vuexI18n.plugin, store)

Vue.i18n.add('ch', translationsCh)
Vue.i18n.add('en', translationsEn)

Vue.i18n.set(localStorage.getItem('locale') || 'ch')

export default store


// WEBPACK FOOTER //
// ./src/store/store.js